import { getKey, getMediaCardSSR } from './globalScope';
export var getSSRData = function getSSRData(identifier, resizeMode) {
  var mediaCardSsr = getMediaCardSSR();
  if (!mediaCardSsr) {
    return;
  }
  return mediaCardSsr[getKey(identifier, resizeMode)];
};